var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { utilNumber } from "../../utils/utilNumber";
import { utilQuickSkip } from "../../utils/utilQuickSkip";
import { utilSkipProcess } from "../../utils/utilSkipProcess";
import { utilTime } from "../../utils/utilTime";
import { IdIcon } from "../generic/icon/IdIcon";
import { TypeBuildingAction } from "../player-base/buildings/reducerBuildings";
import { IdQuickSkip } from "./IdQuickSkip";
import { QuickSkipDialogWrapper } from "./QuickSkipDialogWrapper";
export var QuickSkipConstruction = function (_a) {
    var buildingInConstruction = _a.buildingInConstruction, onCancel = _a.onCancel, building = _a.building, onSkip = _a.onSkip, skipProcessFactor = _a.skipProcessFactor, processTotalTime = _a.processTotalTime;
    if (buildingInConstruction == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var remainingTime = utilQuickSkip.getProcessRemainingTimestamp(buildingInConstruction, IdQuickSkip.Construction);
    var level = buildingInConstruction.proto.stage || 0;
    var timeLeft = utilTime.secondsLeftTill(remainingTime);
    var skipCost = utilSkipProcess.calculateCostToSkipProcess(timeLeft, skipProcessFactor);
    var locaReplacements = new Map([
        [ReplacementLoca.zero_0, utilLoca.get(buildingInConstruction.balancing.locaKey)],
        [ReplacementLoca.one_1, level.toString()],
        [ReplacementLoca.two_2, utilNumber.format(skipCost)],
    ]);
    var quickSkipDialogWrapperProps = {
        description1: IdLoca.quickSkipDialog_constr_desc1,
        description2: IdLoca.quickSkipDialog_constr_desc2,
        icon: IdIcon.ProductionIcn,
        locaReplacements: locaReplacements,
        onCancel: onCancel,
        // Need to pass the "building selected" to reselect this building that caused this modal open
        onSkip: function () { return onSkip(building, TypeBuildingAction.Construct); },
        processTotalTime: processTotalTime,
        remainingTime: remainingTime,
        skipProcessFactor: skipProcessFactor,
        title: IdLoca.quickSkipDialog_constr_title,
    };
    return React.createElement(QuickSkipDialogWrapper, __assign({}, quickSkipDialogWrapperProps));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/QuickSkipConstruction.tsx
// module id = 2892
// module chunks = 3